const sectionReviewGridKindLokalCss = `
[data-type='section-review-grid-kind-lokal'] [data-attribute='review-grid-kind-lokal-container'] {
  padding: 40px 0;
}

[data-type='section-review-grid-kind-lokal'] [data-attribute='review-grid-kind-lokal-container'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-review-grid-kind-lokal'] [data-attribute='review-grid-kind-lokal-container'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal {
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal::-webkit-scrollbar {
  display: none;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .header-review-kind-lokal {
  text-align: center;
  margin-bottom: 40px;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .header-review-kind-lokal .title-review {
  margin-bottom: 40px;
  text-align: center;
  font-size: 24px;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review {
  width: 100%;
  max-width: 100%;
  position: relative;
  padding-bottom: 50px;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review {
  display: flex;
  flex-direction: column;
  height: auto;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card {
  background: #f6f6f6;
  border-radius: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-image-container {
  position: relative;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-image-container .review-image {
  aspect-ratio: 1/1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
  display: block;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-image-container .speech-bubble {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  z-index: 2;
  background: #dd1d1d;
  color: #fff;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  bottom: 0;
  transform: translateY(50%);
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
  margin-bottom: 16px;
  justify-content: center;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars svg {
  fill: #c4c4c4;
  width: 20px;
  height: 20px;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content blockquote {
  flex: 1;
  margin: 0;
  padding: 0;
  text-align: center;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content blockquote p {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 12px;
}

[data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .review-name {
  border-top: 1px solid #1212120f;
  padding-top: 10px;
  text-align: center;
  font-size: 16px;
  font-weight: bold !important;
  margin-top: 12px;
  font-style: italic;
}

@container (max-width: 768px) {
  [data-type='section-review-grid-kind-lokal'] [data-attribute='review-grid-kind-lokal-container'] {
    padding: 16px 0;
  }

  [data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .header-review-kind-lokal {
    margin-bottom: 32px;
  }

  [data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .header-review-kind-lokal .title-review {
    font-size: 18px;
    margin-bottom: 12px;
  }

  [data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review {
    padding-bottom: 30px;
  }

  [data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content blockquote p {
    font-size: 14px;
  }

  [data-type='section-review-grid-kind-lokal'] .wrap-review-grid-kind-lokal .body-review .review-slider .item-review .review-card .review-content .review-name {
    font-size: 14px;
  }
}
`;

export default sectionReviewGridKindLokalCss;
